













































import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AdminUserResult } from "@futuri/cloudsso-client/src/client/types/admin";
import {
  USER_INSTANCE_LEVEL_COMPANY,
  USER_INSTANCE_LEVEL_REGION,
  USER_INSTANCE_LEVEL_MARKET,
  USER_INSTANCE_LEVEL_STATION,
  ProductInstanceResult,
  INSTANCE_STATION
} from "@futuri/cloudsso-client/src/client/types/productInstances";

@Component
export default class UserGeneral extends Vue {
  @Getter("cachedInstances", { namespace: "adminUserPost" })
  instances?: ProductInstanceResult[];

  @Getter("currentUser", { namespace: "adminUserPost" })
  currentUser?: AdminUserResult;
  @Getter("currentCompany", { namespace: "adminUserPost" })
  currentCompany?: string;

  @Getter("isAdminUser")
  isAdminUser?: boolean;
  @Getter("hasUsers")
  hasUsers?: boolean;

  get displayEmail() {
    return this.currentUser?.email;
  }
  get displayCompany() {
    return this.currentCompany;
  }

  get instanceAccessLevels() {
    return [
      { label: "Company Admin", value: USER_INSTANCE_LEVEL_COMPANY },
      { label: "Regional", value: USER_INSTANCE_LEVEL_REGION },
      { label: "Market (Cluster)", value: USER_INSTANCE_LEVEL_MARKET },
      { label: "Station", value: USER_INSTANCE_LEVEL_STATION }
    ];
  }

  get defaultInstanceOptions() {
    interface ListOption {
      label: string;
      value: string;
    }

    const instances = this.instances ?? [];
    const instOpts: ListOption[] = instances.map(
      (inst: ProductInstanceResult) => {
        const { instanceType, instanceId, name } = inst;
        const label =
          instanceType === INSTANCE_STATION
            ? `${name.toUpperCase()} (Station)`
            : name;
        return { label, value: instanceId };
      }
    );

    const genOpts: ListOption[] = [{ label: "(Last Visited)", value: "last" }];

    return genOpts.concat(instOpts);
  }
}
